import React from "react"
import { defineBgColor, retrieveItemImageFromHero } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbCard from "../elements/dfb_card"
import CEpaperCard from "../elements/c_epaper_card"
import Section from "./section"
import CCardCta from "../elements/c_card_cta"

const MCardrow = (props) => {
  let collection = props.data.collection
  collection = retrieveItemImageFromHero(collection)
  return (
    <Section
      baseClass="m-CardRow"
      className={`${
        props.data.grey_background
          ? "u-BgColor-grey"
          : defineBgColor(props.data.background_color)
      }
          ${props.data.add_class ?? ""}`}
      defaultBgColor={"white"}
      defaultPadding="extra-large"
      data={{
        // remove background color, since we need a special handling here
        ...props.data,
        background_color: undefined,
      }}
    >
      <div className="m-CardRow-wrapper">
        <div className="m-CardRow-container m-CardRow-container--headline">
          <div className="c-Headline m-CardRow-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
              testid={props.data.testid}
            />
          </div>
          {props.data.memberCount?.number >= 0 &&
            props.data.memberCount?.label && (
              <div className="m-CardRow-membercount">
                <span className="m-CardRow-membercount-label" data-testid="representative-membercount-label">
                  {props.data.memberCount.label} {props.data.memberCount.number}
                </span>
              </div>
            )}
        </div>
        <div
          className={`c-CardRow m-CardRow-container${
            props.data.card_row_related === true ? " c-CardRow--releated" : ""
          }`}
        >
          <div className="c-CardRow-container">
            {collection.map((item) => (
              <div key={item.uid} className="c-CardRow-card">
                {item.type === "epaper" ? (
                  <CEpaperCard
                    data={Object.assign(item, {
                      add_class: "dfb-Card--cover",
                    })}
                  />
                ) : item.type === "cta" ? (
                  <CCardCta data={item} />
                ) : (
                  <DfbCard
                    data={Object.assign(item, {
                      image_aspect_ratio: "16:9",
                      add_class: "dfb-Card--cover",
                    })}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardrow
